var selectors = {
	'connectif': ['.cn_products', '.cn_product'],
	'photoslurp': ['.ps-container .ps-images', '.ps-image'],
	'variant_selector': ['.variant_selector ul', 'li']
};

function x_scroll(e) {
	var parent = e.currentTarget.parentElement;
	var inside = parent.dataset.inside;

	var scrollable;
	var scrollable_divs;
	var stop = false;

	while (!scrollable) {
		scrollable = parent.querySelector(inside ? selectors[inside][0] : '.four-images-row');
		parent = parent.parentElement;
	}

	if (inside) scrollable_divs = scrollable.querySelectorAll(selectors[inside][1]);
	else scrollable_divs = scrollable.parentElement.querySelectorAll('.four-images-row > div');

	var origin = scrollable.getBoundingClientRect().x;
	var visible = origin + scrollable.getBoundingClientRect().width;

	scrollable_divs.forEach(function(x) {
		if (stop) return;

		var start = x.getBoundingClientRect().x;
		var end = start + x.getBoundingClientRect().width;

		if (e.currentTarget.dataset.factor == 1 && (start >= visible || end > visible + 2)) {
			scrollable.scrollLeft += start - origin;
			stop = true;
		}
		else if (e.currentTarget.dataset.factor == -1 && origin - end <= 32) {
			scrollable.scrollLeft -= visible - end;
			stop = true;
		}
	});
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
	document.querySelectorAll('.arrow_left .feather, .arrow_right .feather').forEach(function(x) {
		x.addEventListener('click', x_scroll);
	});
});
